import { render, staticRenderFns } from "./deliveryCharge.vue?vue&type=template&id=2aa9cba6&"
import script from "./deliveryCharge.vue?vue&type=script&lang=js&"
export * from "./deliveryCharge.vue?vue&type=script&lang=js&"
import style0 from "./deliveryCharge.vue?vue&type=style&index=0&id=2aa9cba6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports